import { client } from '../../lib/urql';

import { createBatchedTableQuery } from './stitchedQueries';
import { GET_WORKSPACE_DATA_QUERY } from '../../../graphql/core/getWorkspaceData.query';
import { GET_INITIAL_TABLE_DATA_QUERY } from '../../../graphql/core/getInitialTableData.query';
import { GET_TABLE_DATA_QUERY } from '../../../graphql/core/getTableData.query';
import {
  GetTableData,
  GetTableDataVariables,
  GetTableData_getTableData,
} from '../../../graphql/core/types/GetTableData';
import {
  GetWorkspaceQuery,
  GetWorkspaceQueryVariables,
} from '../../../graphql/core/types/GetWorkspaceQuery';
import { GetTableDataInput, WorkspaceIdInput } from '../../../types/graphql-global-types';

export interface IBatchedGetTableData {
  [key: string]: GetTableData_getTableData;
}

export const getWorkspaceData = async (workspaceIdInput: WorkspaceIdInput) => {
  const {
    data: { workspace },
  } = await client.query<GetWorkspaceQuery, GetWorkspaceQueryVariables>({
    query: GET_WORKSPACE_DATA_QUERY,
    variables: { workspaceIdInput },
    fetchPolicy: 'no-cache',
  });

  if (workspace === null) {
    throw new Error('`workspace` is missing from `GET_WORKSPACE_DATA_QUERY` result');
  }

  return workspace;
};

export const getInitialTableData = async (getTableDataInput: GetTableDataInput) => {
  const {
    data: { getTableData },
  } = await client.query<GetTableData, GetTableDataVariables>({
    query: GET_INITIAL_TABLE_DATA_QUERY,
    variables: { getTableDataInput },
    fetchPolicy: 'no-cache',
  });

  if (getTableData === null) {
    throw new Error('`getTableData` is missing from initial `GET_INITIAL_TABLE_DATA_QUERY` result');
  }

  return getTableData;
};

export const getBatchedTableData = async (
  getTableDataInput: GetTableDataInput[],
): Promise<IBatchedGetTableData> => {
  const query = createBatchedTableQuery(getTableDataInput);

  const response = await client.query<IBatchedGetTableData>({
    query: query,
    fetchPolicy: 'no-cache',
  });

  return response.data;
};

export const getTableData = async (getTableDataInput: GetTableDataInput) => {
  const {
    data: { getTableData },
  } = await client.query<GetTableData, GetTableDataVariables>({
    query: GET_TABLE_DATA_QUERY,
    variables: { getTableDataInput },
    fetchPolicy: 'no-cache',
  });

  if (getTableData === null) {
    throw new Error('`getTableData` is missing from `GET_INITIAL_TABLE_DATA_QUERY` result');
  }

  return getTableData;
};
